import { render } from "./AssortmentSidebar.vue?vue&type=template&id=72b9c800&scoped=true"
import script from "./AssortmentSidebar.vue?vue&type=script&lang=js"
export * from "./AssortmentSidebar.vue?vue&type=script&lang=js"

import "./AssortmentSidebar.vue?vue&type=style&index=0&id=72b9c800&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b9c800"]])

export default __exports__